import getTrainingAuthSelector from 'modules/training/modules/app-auth/selectors/get'
import { TRAINING_AUTH_KEY } from 'modules/training/modules/app-auth/constants'

const getEmailTrainingAuthSelect = (
  getTrainingAuthSelector(TRAINING_AUTH_KEY.EMAIL)
)

export default getEmailTrainingAuthSelect
